import { render, staticRenderFns } from "./scoreInputBlock.vue?vue&type=template&id=6d7c1135&scoped=true"
import script from "./scoreInputBlock.vue?vue&type=script&lang=js"
export * from "./scoreInputBlock.vue?vue&type=script&lang=js"
import style0 from "./scoreInputBlock.vue?vue&type=style&index=0&id=6d7c1135&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7c1135",
  null
  
)

export default component.exports